import React, { useState, useContext } from 'react';
import { Navbar, Nav, Dropdown } from 'react-bootstrap';
import { Container, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../images/meltshop365.svg';
import { LanguageContext } from '../contexts/LanguageContext';
import '../css/Navbar.css'; 
import { AuthContext } from '../contexts/LoginContext';
import { Link, useNavigate } from 'react-router-dom';

function NavigationBar() {
    const { language, setLanguage } = React.useContext(LanguageContext);
    const { isLoggedIn, setIsLoggedIn } = useContext(AuthContext);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const isCompactWidth = window.innerWidth <= 1366;

    const handleLogout = () => {
        setIsLoggedIn(false);
        localStorage.removeItem('token');
    };

    const handleNavigate = (path: string) => {
        navigate(path);
        setOpen(false);
    };

    return (
        <Navbar expand='xl' className={`bg-body-tertiary ${window.innerWidth <= 1366 ? 'p-2' : 'p-5'}`}>
        <Container>
            <Navbar.Brand as={Link} to="/" style={{ display: 'inline-block', width: window.innerWidth <= 1366 ? '150px' : '250px' }}>
                <img src={logo} alt="Logo" className="d-inline-block align-top img-fluid" style={{ width: '100%', height: 'auto' }} />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className='me-auto'>
                    <Dropdown
                        onMouseEnter={() => setOpen(true)}
                        onMouseLeave={() => setOpen(false)}
                        show={open}
                        drop='down'
                        id="basic-nav-dropdown"
                        className={`custom-link ${window.innerWidth <= 1199 ? '' : 'd-flex justify-content-center'} align-items-center`}
                        >
                            <Dropdown.Toggle
                                as={isCompactWidth ? 'button' : Link}
                                {...(isCompactWidth ? { type: 'button' } : { to: '/merkmale' })}
                                className='custom-link'
                                onClick={(event) => {
                                    if (isCompactWidth) {
                                        event.preventDefault();
                                        handleNavigate('/merkmale');
                                    }
                                }}
                            >
                                {language === 'de' ? 'MERKMALE' : 'FEATURES'}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item as={Link} to="/administration" className="outlined-dropdown-item dropdown-items" onClick={() => handleNavigate('/administration')}>
                                    <p className='mb-1'>
                                    {language === 'de' ? 'ADMINISTRATION' : 'ADMINISTRATION'}
                                    </p>
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/produktionsplanung" className="outlined-dropdown-item dropdown-items" onClick={() => handleNavigate('/produktionsplanung')}>
                                    <p className='mb-1'>
                                    {language === 'de' ? 'PRODUKTIONSPLANUNG' : 'PRODUCTIONPLANNING'}
                                    </p>
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/rohstoffoptimierung" className="outlined-dropdown-item dropdown-items" onClick={() => handleNavigate('/rohstoffoptimierung')}>
                                    <p className='mb-1'>
                                    {language === 'de' ? 'ROHSTOFFOPTIMIERUNG' : 'RAW MATERIAL OPTIMIZATION'}
                                    </p>
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/materialwirtschaft" className="outlined-dropdown-item dropdown-items" onClick={() => handleNavigate('/materialwirtschaft')}>
                                    <p className='mb-1'>
                                    {language === 'de' ? 'MATERIALWIRTSCHAFT' : 'MATERIAL MANAGEMENT'}
                                    </p>
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/schmelzplanung" className="outlined-dropdown-item dropdown-items" onClick={() => handleNavigate('/schmelzplanung')}>
                                    <p className='mb-1'>
                                    {language === 'de' ? 'SCHMELZPLANUNG' : 'HEAT PLANNING'}
                                    </p>
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/einsatzberechnung" className="outlined-dropdown-item dropdown-items" onClick={() => handleNavigate('/einsatzberechnung')}>
                                    <p className='mb-1'>
                                    {language === 'de' ? 'EINSATZBERECHNUNG' : 'CHARGE CALCULATION'}
                                    </p>
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/prozessautomatisierung" className="outlined-dropdown-item dropdown-items" onClick={() => handleNavigate('/prozessautomatisierung')}>
                                    <p className='mb-1'>
                                    {language === 'de' ? 'PROZESSAUTOMATISIERUNG' : 'PROCESS AUTOMATION'}
                                    </p>
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/controlling" className="outlined-dropdown-item dropdown-items" onClick={() => handleNavigate('/controlling')}>
                                    <p className='mb-1'>
                                    {language === 'de' ? 'CONTROLLING' : 'CONTROLLING'}
                                    </p>
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/auftragsabrechnung" className="outlined-dropdown-item dropdown-items" onClick={() => handleNavigate('/auftragsabrechnung')}>
                                    <p className='mb-1'>
                                    {language === 'de' ? 'AUFTRAGSABRECHNUNG' : 'ORDER ACCOUNTING'}
                                    </p>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    <Nav.Link as={Link} to="/system" className="custom-link">
                        {language === 'de' ? 'SYSTEM' : 'SYSTEM'}
                    </Nav.Link>
                    <Nav.Link as={Link} to="/processvars" className="custom-link">
                        {language === 'de' ? 'PROCESSVARS' : 'PROCESSVARS'}
                    </Nav.Link>
                    <Nav.Link as={Link} to="/lizenzierung" className="custom-link">
                        {language === 'de' ? 'LIZENSIERUNG' : 'LICENSING'}
                    </Nav.Link>
                    <Nav.Link as={Link} to="/kontakt" className="custom-link">
                        {language === 'de' ? 'KONTAKT' : 'CONTACT'}
                    </Nav.Link>
                    {/*<Nav.Link href="/news" className="custom-link">
                        {language === 'de' ? 'NEWS' : 'NEWS'}
                    </Nav.Link>'*/}
                </Nav>
                <Nav className="d-flex flex-row">
                    <Nav.Link as={Link} to="/" onClick={(e) => { e.preventDefault(); setLanguage('de'); }} className={`language-selector ${language === 'de' ? 'font-weight-bold' : ''}`}>de</Nav.Link>
                    <div className="border-right mx-2 pt-2">&zwj;</div>
                    <Nav.Link as={Link} to="/" onClick={(e) => { e.preventDefault(); setLanguage('en'); }} className={`language-selector ${language === 'en' ? 'font-weight-bold' : ''}`}>en</Nav.Link>
                    {isLoggedIn ? (
                        <Button onClick={handleLogout} variant="danger" className="mx-3">
                            Logout
                        </Button>
                    ) : null}
                </Nav>
            </Navbar.Collapse>
        </Container>
        </Navbar>
    );
}

export default NavigationBar;
